module.exports = __webpack_public_path__ + "img/3.f1724ce6.png";